import { useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar, MobileSidebar } from "./sidebar";
import { TopBar } from "./topbar";
import { CommandPalette } from "@/components/command-palette";
import { BreadcrumbProvider } from "./breadcrumb-context";
import { ErrorBoundary } from "@/components/error-boundary";

export function AppShell() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuTriggerRef = useRef<HTMLButtonElement>(null);

  return (
    <BreadcrumbProvider>
      {/* Skip link for keyboard navigation */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:z-50 focus:bg-primary focus:text-primary-foreground focus:outline-none focus:ring-2 focus:ring-ring"
      >
        Skip to main content
      </a>

      <div className="flex h-screen overflow-hidden bg-sidebar">
        {/* Full-height sidebar on desktop (hidden on mobile) */}
        <Sidebar />

        {/* Workbench content column */}
        <div className="flex min-w-0 flex-1 flex-col overflow-hidden bg-background">
          <TopBar
            onMenuToggle={() => setMobileMenuOpen(true)}
            menuTriggerRef={menuTriggerRef}
          />
          <main
            id="main-content"
            className="min-w-0 flex-1 overflow-y-auto"
            role="main"
          >
            <ErrorBoundary
              variant="panel"
              title="Failed to display page"
              description="An unexpected error occurred while rendering this view."
            >
              <Outlet />
            </ErrorBoundary>
          </main>
        </div>

        <MobileSidebar
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
          triggerRef={menuTriggerRef}
        />
        <CommandPalette />
      </div>
    </BreadcrumbProvider>
  );
}
